type Translator = (key: string, params?: Record<string, string | number>) => string;

const KNOWN_TABLES = new Set([
  "leads",
  "deals",
  "managers",
  "calls",
  "messages",
  "contacts",
  "pipelines",
  "pipeline_statuses",
  "pipeline_events",
  "pipeline_events_full",
]);

const KNOWN_TOOLS = new Set([
  "list_tables",
  "describe_table",
  "query_ch",
  "get_last_report_sql",
  "get_tenant_info",
  "ask_user",
]);

function tableLabel(t: Translator, name: string): string {
  if (KNOWN_TABLES.has(name)) return t(`table.${name}`);
  return name;
}

export function formatStepLabel(
  toolName: string,
  toolInput: Record<string, unknown> | undefined,
  t: Translator,
): string {
  if (toolName === "describe_table") {
    const name = typeof toolInput?.name === "string" ? toolInput.name : "";
    return t("step.describe_table", { table: tableLabel(t, name) });
  }
  if (KNOWN_TOOLS.has(toolName)) return t(`step.${toolName}`);
  return toolName;
}
